module.exports = __webpack_public_path__ + "img/clock.f1e93db3.png";